import React from 'react';
import { shallowEqual } from 'react-redux';

import getGlobalConditionsFromOtherSpreads from 'editor/src/store/design/selector/getGlobalConditionsFromOtherSpreads';
import { conditionGroupChildenKey } from 'editor/src/store/design/types';
import getCurrentSpreadIndex from 'editor/src/store/editor/selector/getCurrentSpreadIndex';
import { useSelector } from 'editor/src/store/hooks';

import PersonalizationElements from './PersonalizationElements';
import PersonalizationCondition from './PersonalizationElements/PersonalizationCondition';

import styles from './index.module.scss';

function PersonalizationContent() {
  const { conditionGroup, spreadIndex, globalConditions } = useSelector((state) => {
    const spreadIndex = getCurrentSpreadIndex(state);
    return {
      spreadIndex,
      conditionGroup: state.design.designData?.spreads[spreadIndex]?.conditionGroup,
      globalConditions: getGlobalConditionsFromOtherSpreads(state, spreadIndex),
    };
  }, shallowEqual);

  if (!conditionGroup && globalConditions.length === 0) {
    return null;
  }

  return (
    <>
      {conditionGroup && (
        <PersonalizationElements
          spreadIndex={spreadIndex}
          conditionGroup={conditionGroup}
          elements={conditionGroup.children[conditionGroupChildenKey] || []}
          personalizationElementClassName={styles.personalisationElement}
        />
      )}
      {globalConditions.map(({ spreadIndex: owningSpreadIndex, conditionGroup: owningGroup, condition }) => (
        <PersonalizationCondition
          key={condition.id}
          spreadIndex={owningSpreadIndex}
          conditionGroup={owningGroup}
          condition={condition}
          isBuilding={false}
          textOnly={false}
          optionsOnly
        />
      ))}
    </>
  );
}

export default React.memo(PersonalizationContent);
